<ng-container *ngIf="wishlists$ | async as wishlists">
    <div *ngIf="wishlists.length <= 1; else multi" (click)="addToWishlist(wishlists[0].id)">
        <div *ngIf="customButtonTemplate()">
            <!-- required due to https://github.com/angular/angular/issues/50543 -->
            <ng-content />
            <ng-container *ngTemplateOutlet="customButtonTemplate()"></ng-container>
        </div>
        <button
            *ngIf="!customButtonTemplate()"
            class="btn-icon text-sm p-2"
            [disabled]="disabled"
            title="Add to wishlist"
        >
            <fa-icon
                [icon]="inWishlists?.length || added.has(variantId) ? heartSolid : heart"
                class=""
            ></fa-icon>
            {{ showLabel ? label : '' }}
        </button>
    </div>

    <ng-template #multi>
        <vsf-dropdown #dropdown [position]="['bottom']" *ngIf="wishlists.length > 1">
            <div vsfDropdownTrigger class="inline">
                <div *ngIf="customButtonTemplate()">
                    <ng-container *ngTemplateOutlet="customButtonTemplate()"></ng-container>
                </div>
                <button class="btn-icon text-sm p-2" *ngIf="!customButtonTemplate()" [disabled]="disabled">
                    <fa-icon
                        [icon]="inWishlists?.length || added.has(variantId) ? heartSolid : heart"
                        class=""
                    ></fa-icon>
                    {{ showLabel ? label : '' }}
                </button>
            </div>
            <div class="p-4 divide-y divide-gray-200" vsfDropdownContent>
                <button
                    (click)="addToWishlist(wishlist.id)"
                    class="py-2 rounded hover:bg-gray-100 transition-colors w-full"
                    *ngFor="let wishlist of wishlists"
                    [title]="'Add to wishlist: ' + wishlist.name"
                >
                    {{ wishlist.name }}
                    <span
                        class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                        [ngClass]="
                            wishlist.isPublic ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'
                        "
                    >{{ wishlist.isPublic ? 'public' : 'private' }}</span
                    >
                </button>
            </div>
        </vsf-dropdown>
    </ng-template>
</ng-container>
